import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useContext,
} from "react";
import axios from "axios";
import { Header } from "./components/header";
import { Footer } from "./components/footer";

import "./guide.css";
import { Content } from "./globalType";
import { getHost, translate2 } from "./utils";
import { AuthContext } from "./auth";
import { TailSpin } from "react-loader-spinner";
import { DateTime } from "luxon";
import { useSearchParams } from "react-router-dom";
import {EmagPagination} from './components/pagination'
import { EmagSubMenu } from "./components/submenu";

declare var $: any;

type EmagProps = {
  goToPage: (page: string, content: Content | null) => void;
};

type EmagFile = {
  cover_image: string;
  created_at: number;
  id: string;
  pdf: string;
  title: string;
  updated_at: number;
}

function Emag(props: EmagProps) {
  const { goToPage } = props;
  let [searchParams, setSearchParams] = useSearchParams();
  const [emags, setEmags] = useState<EmagFile[]>([])
  const [total, setTotal] = useState<number>(0)
  const [page, setPage] = useState<string>('1')
  const [isLoading, setLoading] = useState<boolean>(true)
  const authContext = useContext(AuthContext);

  const p = searchParams.get('page');

  if (p && page !== p) {
    setPage(p)
  }

  // useEffect(() => {
  //   fetchContents(0, 10);
  // }, []);

  useEffect(() => {
    if (page) {
      try {
        const pNumber = parseInt(page, 10);
        fetchContents((pNumber - 1) * 10, 10);
      } catch (error) {
        console.log(error)
      }
    }
  }, [page])

  const fetchContents = async (start:number, limit:number) => {
    try {
      const result = await fetchEmags(start, limit);
      setEmags(result.data.mags);
      setTotal(result.data.rowcount);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  
  return (
    <>
      <Header goToPage={goToPage} />
      {isLoading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <TailSpin color="#00BFFF" height={150} width={150} />
        </div>
      )}
      <EmagSubMenu goToPage={goToPage} />
      <div>
        <div className="container H-container live-title">
          <p className="text-center">{translate2('ทรูวิชันส์ อีแม็กกาซีน', 'True Visions e-magazine', authContext?.lang)}</p>
        </div>
        <div className="container H-container">
          <div className="guide-BG">
            {emags.map((e, index) => {
              const pdfProps:any = {source: e.pdf}
              const created_at = DateTime.fromMillis(e.created_at).setLocale(authContext?.lang as string)
              return (
                <div key={index} className="list">
              <div>
                <div className="pic">
                  <img src={e.cover_image} alt="" />
                </div>
                <div className="detail">
                  <div>
                    <h5 className="title-g">{e.title}</h5>
                    <p>
                      <img src="/ondemand/static/img/clock-pink.png" alt="time" />
                      <span>{created_at.toFormat('d LLLL yyyy')}</span>
                    </p>
                  </div>
                  <a className="download-BT _PDFF_link" {...pdfProps}>
                    <img
                      src="/ondemand/static/img/download-white.png"
                      alt="down"
                    />
                    {translate2('เปิด', 'Open', authContext?.lang)}
                  </a>
                </div>
              </div>
            </div>
              )
            })}
          </div>
          <EmagPagination page={page} total={total} />
          
        </div>
      </div>
      <Footer />
    </>
  );
}

async function fetchEmags(start: number, limit: number) {
  const host = getHost();
  return axios.get(`${host}/api/e-mags?start=${start}&limit=${limit}`);
}

export default Emag;
